import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import './css/general.css';
import styles from './css/Score.module.css';
import axiosInstance from '../services/AxiosInstance';


interface LevelProps extends RouteComponentProps {
  // Define the props here
}
interface LevelState {
  // Define the state here
  challengeList: Challenge[];
  level: number;
  challengesLeft: number;
}

interface ChallengeInterface{
    challengeId: number,
    challengeTitle: string,
    challengeScore: number,
    questions: number
    subjectId: number
}


class Challenge implements ChallengeInterface {
challengeId: number;
challengeTitle: string;
challengeScore: number;
questions: number;
subjectId: number

    constructor(challengId: number, challengeTitle: string, challengeScore: number, questions: number, subjectId: number) {
      this.challengeId = challengId;
      this.challengeTitle = challengeTitle
      this.challengeScore = challengeScore
      this.questions = questions
      this.subjectId = subjectId
    }
}


class LevelPage extends React.Component<LevelProps, LevelState>{
  constructor(props: LevelProps) {
    super(props);

    this.state = {
        challengeList:[
            {
                challengeId: 0,
                challengeTitle: "",
                challengeScore: 0,
                questions: 0,
                subjectId: 0
            }
        ],
        level: 0,
        challengesLeft: 0
    }
    this.getChallenges()
  }

  async getChallenges(){
    var id = localStorage.getItem("id");
    var token = localStorage.getItem("token");

    let challengesDone: number = 0

  axiosInstance
  .get(
      "/Results/Employee/" + id,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
  .then((res) => {
      console.log(res.data);
      res.data.forEach((element: any) => {
        //console.log(element.challenge);
        this.state.challengeList.push({
            challengeId: element.challenge.id,
            challengeTitle: element.challenge.title,
            challengeScore: element.score,
            questions: element.challenge.questions.length,
            subjectId: element.challenge.subjectId
        })

        if(element.score >= 0) {
          challengesDone ++
        }
    });
    //console.log(this.state.challengeList)
    this.state.challengeList.splice(0, 1);

    // Meest recente challenge bovenaan
    this.state.challengeList.sort(function(a, b){return b.challengeId - a.challengeId});

    this.setState({ challengeList: this.state.challengeList});
    this.getLevel(challengesDone)

    })
  }

  async getLevel(challengesDone: number){
    let level:number = 1
    let challengesForNextLevel:number[] = [3,4,3,2]
    let challengesToDo = challengesForNextLevel[0]
    let index: number = 0

    while(challengesDone >= challengesToDo) {
       challengesDone -= challengesToDo;
       level ++;
       if(index % 2 == 0) {
           challengesForNextLevel.push(3)
       } else {
           challengesForNextLevel.push(2)
       }
       index ++
       challengesToDo = challengesForNextLevel[index]
    }

    let challengesLeftForNextLevel = challengesToDo -= challengesDone

    //console.log(level)
    this.setState({level: level})
    this.setState({challengesLeft: challengesLeftForNextLevel})
 }

  goToMoodOverview(){
    const {history} = this.props;
    localStorage.setItem("challengeList", JSON.stringify(this.state.challengeList))
    history.push("/moodOverviewAll");
}
  goToChallengeOverview(){
    const {history} = this.props;
    localStorage.setItem("challengeList", JSON.stringify(this.state.challengeList))
    history.push("/AllChallenges");
}


  render() {

    let challengeOverview;
    if(this.state.challengeList.length == 0){
      challengeOverview =
    <div className={`${styles.panel} ${styles.disabled}`}>
      <h1 className={styles.title}>Challenges overzicht</h1>
      <p className={(styles.info)}>Om een overzicht van je challenges te kunnen bekijken, moet je minstens 1 challenge voltooien</p>
    </div>
    } else{
      challengeOverview =
    <div className={styles.panel} onClick={() => this.goToChallengeOverview()}>
    <h1 className={styles.title}>Challenges overzicht</h1>
    <p className={(styles.info)}>Klik hier om een overzicht van al je deelgenomen challenges te bekijken</p>
    </div>
    };

    let moodOverview;
    if(this.state.level >= 4){
    moodOverview =
    <div className={styles.panel} onClick={() => this.goToMoodOverview()}>
    <h1 className={styles.title}>Mood overzicht</h1>
    <p className={(styles.info)}>Klik hier om een overzicht over je moods over alle challenges heen te bekijken</p>
    </div>

    } else{
    moodOverview =
    <div className={`${styles.panel} ${styles.disabled}`}>
      <h1 className={(styles.title)}>Mood overzicht</h1>
      <p className={(styles.info)}>Om een overzicht over je moods te kunnen bekijken, moet je minstens level 4 zijn</p>
    </div>
    };
      

    return (
      <IonPage>
        <IonHeader class="ion-no-border">
          <IonToolbar>
          <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
            <IonTitle>Level</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
            <div className={styles.subjects}>
              <div className= {styles.flexDetail}>
                <div className={styles.detailPanel}>
                  <h1 className={styles.title}>Huidig level:</h1>
                  <p className={styles.detail}>{this.state.level}</p>
                </div>
                <div className={styles.detailPanel}>
                  <h1 className={styles.title}>Aantal quizzen voltooien voor volgende level:</h1>
                  <p className={styles.detail}>{this.state.challengesLeft}</p>
                </div>
              </div>
  
                {challengeOverview}
                {moodOverview}
            </div>
        </IonContent>
      </IonPage>
    );
  }
};

export default withRouter(LevelPage)
